import * as React from "react";
const SvgQuestion = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.25a9.25 9.25 0 1 0 0-18.5 9.25 9.25 0 0 0 0 18.5ZM22.75 12c0 5.937-4.813 10.75-10.75 10.75S1.25 17.937 1.25 12 6.063 1.25 12 1.25 22.75 6.063 22.75 12Zm-12 4.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM9.723 8.286c0-.434.14-.839.45-1.138.31-.298.881-.578 1.914-.578 1.06 0 1.565.256 1.813.507.248.25.378.636.378 1.209 0 .326-.084.5-.251.702-.1.12-.231.248-.414.419l-.108.1c-.154.143-.334.31-.521.497-.134.134-.243.235-.355.338-.073.068-.147.136-.23.216-.19.182-.39.39-.561.654-.358.554-.501 1.224-.501 2.22a.75.75 0 1 0 1.5 0c0-.863.127-1.199.261-1.407.075-.117.177-.23.338-.383.046-.045.105-.1.172-.162.13-.12.29-.268.436-.415.166-.166.32-.308.472-.45l.12-.111c.184-.172.377-.356.544-.556a2.45 2.45 0 0 0 .598-1.662c0-.771-.173-1.618-.812-2.264-.638-.646-1.605-.952-2.88-.952-1.302 0-2.288.359-2.952.997-.662.636-.911 1.463-.911 2.219a.75.75 0 1 0 1.5 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgQuestion;
